import { render, staticRenderFns } from "./left.vue?vue&type=template&id=4d79a88e&"
import script from "./left.vue?vue&type=script&lang=js&"
export * from "./left.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports